import { Component, OnInit } from '@angular/core';
import {JhiLanguageService, DateUtils} from 'ng-jhipster';

import { Principal, AccountService, JhiLanguageHelper } from '../../shared';
import {CALENDAR_FR} from '../../shared/calendar/calendar.constants';
import {DatePipe} from '@angular/common';

@Component({
    selector: 'jhi-settings',
    templateUrl: './settings.component.html'
})
export class SettingsComponent implements OnInit {
    error: string;
    success: string;
    settingsAccount: any;
    languages: any[];
    fr: any;

    constructor(
        private account: AccountService,
        private principal: Principal,
        private languageService: JhiLanguageService,
        private languageHelper: JhiLanguageHelper) {
        this.languageService.setLocations(['settings']);
    }

    ngOnInit () {
        this.principal.identity().then((account) => {
            account.birthDate = account.birthDate != null ? new Date(account.birthDate) : null;
            this.settingsAccount = account;
        });
        this.languageHelper.getAll().then((languages) => {
            this.languages = languages;
        });
        this.fr = CALENDAR_FR;
    }

    save () {
        this.account.save(this.settingsAccount).subscribe(() => {
            this.error = null;
            this.success = 'OK';
            this.principal.identity(true).then((account) => {
                account.birthDate = account.birthDate != null ? new Date(account.birthDate) : null;
                this.settingsAccount = account;
            });
            this.languageService.getCurrent().then((current) => {
                if (this.settingsAccount.langKey !== current) {
                    this.languageService.changeLanguage(this.settingsAccount.langKey);
                }
            });
        }, () => {
            this.success = null;
            this.error = 'ERROR';
        });
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/settings/settings.component.ts